import {getBFF} from "@/function/getUrlProdOrPreprod";
import {CreateEngagement} from "@/ts/interface/detailOffre";

import {callApi} from "./_callApi";

export async function postEngagements(
  id: string,
  engagement: CreateEngagement[],
): Promise<any> {
  const postEngagement = {engagements: engagement};
  if (import.meta.env.VITE_APP_DEV === "true") {
    const reponse = await callApi(
      `${import.meta.env.VITE_APP_API}/api/massification/v1/offres/${id}/engagements`,
      "POST",
      {
        "Content-Type": "application/json",
        Authorization:
          "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJFUzUxMiIsImtpZCI6IjEifQ.eyJpYXQiOjE3NTQ2NTU4ODguNzU2NzY3LCJuYmYiOjE3NTQ2NTU4ODguNzU2NzY3LCJleHAiOjIwNzAxODg2ODguNzU2NzY3LCJzdWIiOiJjeXJpbEBicmljb3Bybzc5LmZyIiwiY29udHJlbWFycXVlIjoiMTA0MDAwIiwiZXh0cmFuZXQtaWQiOiIxNzgifQ.ATetmxOXN-UhksNfGbGrxg3Tn5eiuJv7iI-_jfd2Jg70cH-dCoCyqc8d6OYTF07mMmNCUhsKZ9wcZIA1u7KEYQWdAOs90-2gUorR2ZKoJ3o7bis1WcTwZT2NmnCIXA_o51SzrCWba-Grf3rbTzhZaf65uatdhJtj1udI-taA--Y_uS_S",
      },
      "same-origin",
      postEngagement,
    );
    return reponse;
  } else {
    const reponse = await callApi(
      `${getBFF()}/massification/v1/offres/${id}/engagements`,
      "POST",
      {
        "Content-Type": "application/json",
        "Accept-Encoding": "gzip, deflate, br",
        "X-Massification-CSRF-Token": csrf,
        "X-CoDeals-CSRF-Token": csrf,
      },
      "include",
      postEngagement,
    );

    return reponse;
  }
}
